import React, { useEffect, useRef, useState } from "react";

import { useRouter } from "next/router";
import Head from "next/head";
import Image from "next/image";
import * as Dialog from "@radix-ui/react-dialog";
import { AiOutlineClose } from "react-icons/ai";
import { getOGimage, getUrl } from "../utils/getUrl";
import { motion } from "framer-motion";
import { capture } from "../utils/analytics/capture";

function UlaApp() {
  const router = useRouter();

  const isFirstRender = useRef(true);
  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      // if (router.query?.referral === "1") {
      //   setActiveTab(1);
      // }
      getApps();

      // console.log("routed to here", router.pathname);
      return;
    }
  });

  const [appInstalled, setAppInstalled] = useState(false);

  const getApps = async () => {
    try {
      let apps = await navigator.getInstalledRelatedApps();
      if (apps.length > 0) {
        // apps.forEach((app) => {
        //   console.log(app.id, app.platform, app.url);
        // });
        setAppInstalled(apps[0].id === "com.ulaafrica.app");
      } else {
        setAppInstalled(false);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const [open, setOpen] = useState(false);

  const containerStyle = {
    position: "relative",
    width: "3rem",
    height: "3rem",
    margin: "1rem",
  };
  const circleStyle = {
    display: "block",
    width: "3rem",
    height: "3rem",
    border: "0.5rem solid #e9e9e9",
    borderTop: "0.5rem solid #3498db",
    borderRadius: "50%",
    position: "absolute",
    boxSizing: "border-box",
    top: 0,
    left: 0,
  };
  const spinTransition = {
    loop: Infinity,
    duration: 0.2,
    ease: "linear",
  };

  return (
    <>
      <Head>
        <meta name="viewport" content="initial-scale=1.0, width=device-width" />
        <meta charSet="utf-8" />
        <title>Ula Homes App</title>
        <link rel="canonical" href={`${getUrl()}/ula-app`} />
        <meta
          name="description"
          content="Experience hassle-free home search with the Ula Africa App. Compare home prices, number of rooms and more. Connect with agents—all in one place. Download the app now and simplify your home search"
        />
        <meta name="og:title" content="Get the App" />
        <meta
          name="og:description"
          content="Experience hassle-free home search with the Ula Africa App. Compare home prices, number of rooms and more. Connect with agents—all in one place. Download the app now and simplify your home search."
        />

        <meta name="og:image" content={`${getOGimage()}`} />
        <meta property="og:url" content={`${getUrl()}/ula-app`} />
      </Head>

      {/* <div style={containerStyle}>
        <motion.span
          style={circleStyle}
          animate={{
            rotate: 360,
          }}
          // transition={spinTransition}
        ></motion.span>
      </div> */}

      <div className=" flex flex-col items-center bg-white px-8 pb-20 pt-12   lg:h-[80vh] lg:flex-row lg:px-24 lg:py-0">
        <div className=" flex w-full flex-col space-y-8 lg:w-1/2 lg:space-y-5">
          <div className="flex flex-col space-y-2 lg:space-y-4">
            <h1 className="  text-4xl font-bold lg:text-6xl">
              Find homes easily. <br></br>Get the Ula Homes App.
            </h1>
            <h2 className=" mr-12 lg:mr-20  lg:text-lg">
              Experience hassle-free home search with the Ula App. Compare home
              prices, number of rooms and more. Connect with agents—all in one
              place. <br></br>{" "}
              {router.query?.referral === "1" ? (
                <span>
                  Get your{" "}
                  <span className=" font-semibold">unique referral link </span>
                  from app to refer an agent
                </span>
              ) : (
                "Get the app now!"
              )}
            </h2>
          </div>
          <div className=" ">
            <motion.button
              initial={{
                scale: 1,
              }}
              // animate={{
              //   scale: 1.05,
              // }}
              // transition={{
              //   loop: Infinity,
              //   duration: 1.2,
              //   ease: "linear",
              // }}
              onClick={() => {
                setOpen(true);
                capture({
                  category: "browse",
                  event: "get_app_click",
                  properties: {
                    referral: router.query?.referral === "1",
                  },
                });
              }}
              className=" hidden rounded-md bg-ula-primary px-16 py-4 font-semibold text-gray-100 lg:flex"
            >
              Get the app
            </motion.button>
            <a
              onClick={() => {
                capture({
                  category: "browse",
                  event: "get_app_click",
                  properties: {
                    app_already_installed: appInstalled,
                    referral: router.query?.referral === "1",
                    mobile: true,
                  },
                });
              }}
              href="https://homes.ula.africa/app"
              className=" rounded-md   bg-ula-primary px-16 py-4 font-semibold text-gray-100 lg:hidden"
            >
              {appInstalled ? "Open app" : "Get the app"}
            </a>
          </div>
        </div>
        <div className=" relative  h-104 w-full lg:h-[30rem] lg:w-1/2 ">
          {/* <div className=' h-40 w-40 bg-blue-50 rounded-full absolute  top-12 left-20'></div> */}
          <div className=" absolute left-0 top-16  h-88 w-88 rounded-full bg-ula-background lg:left-5 lg:top-16  lg:h-104 lg:w-104"></div>
          <Image
            className=" object-contain pt-10"
            src="/image/store.png"
            layout="fill"
            alt="Ula africa app in stores"
          />
        </div>
      </div>

      <Dialog.Root
        open={open}
        onOpenChange={(open) => {
          setOpen(open);
        }}
      >
        <Dialog.Trigger />
        <Dialog.Portal>
          <Dialog.Overlay />
          <Dialog.Content className=" fixed inset-0 hidden h-screen w-full flex-col items-center justify-center bg-gray-100 lg:flex">
            <div className=" mb-0 mr-40 flex w-3/4 justify-end">
              <Dialog.Close>
                <div
                  onClick={() => {
                    setOpen(false);
                  }}
                  className=" rounded-full  p-3 hover:bg-gray-400"
                >
                  <AiOutlineClose className=" h-6 w-6" />
                </div>
              </Dialog.Close>
            </div>
            <Dialog.Title />
            <Dialog.Description />
            <div className=" flex flex-row items-center space-x-24">
              <div className=" flex  w-1/2 justify-end ">
                <div className=" border border-gray-300 p-12">
                  <div className=" relative  h-72 w-72 rounded-lg bg-white shadow-xl  shadow-blue-200  drop-shadow-2xl ">
                    <Image
                      className=""
                      src="/image/store-link.png"
                      layout="fill"
                      alt="Ula Africa App in Stores"
                    />
                  </div>
                </div>
              </div>
              <div className=" flex flex-col space-y-3">
                <span className="  text-4xl font-extrabold">
                  Scan the QR code to get <br></br> the Ula app.
                </span>
                <span className=" w-3/5 text-lg  text-gray-800">
                  {router.query?.referral === "1"
                    ? " Get you personal referral link. Scan the QR code with your phone and download the Ula app. "
                    : " Find homes hassle free! Scan the QR code with your phone and get the free Ula app. "}
                </span>
              </div>
            </div>
          </Dialog.Content>
        </Dialog.Portal>
      </Dialog.Root>
    </>
  );
}

export default UlaApp;
